import styled, { css } from "styled-components";

const Media = {
  Laptop: "@media(max-width:1220px)",
  Nav: "@media(max-width:1000px)",
  Tablet: "@media(max-width:1000px)",
  PhoneLarge: "@media(max-width:600px)",
  PhoneSmall: "@media(max-width:400px)",
};

export const HeaderContainer = styled.header`
  position: fixed;
  z-index: 99;
  width: 100%;
  top: 1.5rem;

  .header {
    position: absolute;
    width: 100%;
    z-index: 1;
    background-color: var(--branco-color);
    box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 5px;

    .logoSide {
      position: relative;
      width: 210px;
      height: auto;

      .logo {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        max-width: 210px;
        height: auto;
        transition: opacity 0.5s ease-in-out;

        ${Media.Laptop} {
          width: 90% !important;
        }
      }

      img {
        transition: all 0.5s linear 0.1s;
        width: 100%;
        max-width: 210px;

        ${Media.Nav} {
          width: 80% !important;
        }
      }

      ${({ isanimation }) => isanimation && css``}
    }

    ul {
      list-style-type: none;
      padding-left: 0;
    }

    .logoSide .visible {
      opacity: 1;
      z-index: 1;
    }

    .logoSide .hidden {
      opacity: 0;
      z-index: 0;
    }

    ul,
    li {
      text-decoration: none;
    }
    .logoSide {
      cursor: pointer;
    }

    ul,
    li,
    a {
      list-style: none;
    }

    .light {
      color: var(--branco-color) !important;
      ${({ isanimation }) =>
        isanimation &&
        css`
          color: var(--verde-color) !important;
        `}
    }

    .content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 6rem;
      width: 90%;
      margin: auto;
      max-width: 90rem;

      .menu {
        display: none;

        ${Media.Nav} {
          display: block;
          width: 3em;
          height: 3em;
          color: var(--preto-color);
          opacity: 1;
          transition: all 0.5s linear 0.1s;

          ${({ isVisible }) =>
            isVisible &&
            css`
              opacity: 0;
              color: var(--branco-color);
              transition: all 0.5s linear 0.1s;
            `}
        }
      }

      .closeMenu {
        position: absolute;
        opacity: 0;
        z-index: -1;
        right: 5%;
        transition: all 0.1s linear;

        ${Media.Nav} {
          ${({ isVisible }) =>
            isVisible &&
            css`
              z-index: 0;
              opacity: 1;
            `}
        }
      }

      .menuSide {
        gap: 2rem;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        ${Media.Nav} {
          width: 100%;
          height: 100vh;
          margin-left: 100%;
          padding: 0 45px 30px 0px;
          position: absolute;
          top: -1.5rem;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: -2;
          align-items: flex-end;
          flex-direction: column;
          backdrop-filter: blur(25px);
          background: rgb(0 0 0 / 80%);

          ${({ isVisible }) =>
            isVisible &&
            css`
              transition: margin-left 0.8s cubic-bezier(0.65, 0.05, 0.36, 1);
              opacity: 1;
              margin-left: 0px;
            `}
        }

        ${Media.Laptop} {
          gap: 1.5rem;
        }

        .Options {
          color: var(--preto-color);
          font-size: 22px;
          font-weight: 400;
          position: relative;

          a {
            color: var(--preto-color);

            ${Media.Nav} {
              color: var(--branco-color);
            }

            &:hover {
              transition: all 0s linear;
              color: var(--vinho-color);
              border-bottom: 2px solid var(--vinho-color);
            }
          }

          ${Media.Laptop} {
            font-size: 1.1rem;
          }

          ${Media.Nav} {
            font-size: 1.5rem;
            font-weight: bold;
            color: var(--branco-color);
          }
        }

        .Options a.active {
          color: var(--vinho-color) !important;
          border-bottom: 2px solid var(--vinho-color);
        }

        .Options.active a {
          color: var(--vinho-color) !important;
          border-bottom: 2px solid var(--vinho-color);
        }
      }
    }

    .language-mobile {
      display: none;

      ${Media.Nav} {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;

        .containerList {
          list-style-type: none;
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          align-items: center;
          gap: 5px;
        }

        p {
          margin-bottom: 3px;

          ${Media.Tablet} {
            color: var(--branco-color) !important;
          }
        }

        .list button {
          text-transform: uppercase;
          font-size: 19px;
          font-weight: bold;
          position: relative;
          -webkit-transition: all 0.3s ease-out 0s;
          -moz-transition: all 0.3s ease-out 0s;
          -ms-transition: all 0.3s ease-out 0s;
          -o-transition: all 0.3s ease-out 0s;
          transition: all 0.3s ease-out 0s;
          cursor: pointer;
          background-color: transparent !important;
          padding: 0 0.4rem !important;
          color: var(--preto-color) !important;
          border-radius: 0 !important;

          ${Media.Laptop} {
            font-size: 1.1rem;
          }

          ${Media.Nav} {
            font-size: 20px;
            color: var(--branco-color) !important;
          }
        }

        .list button:hover {
          color: var(--vinho-color) !important;
          transition: all 0.5s;
        }

        .list button.selectLanguage {
          color: var(--vinho-color) !important;
          border-bottom: 1px solid var(--vinho-color);
        }
      }
    }

    .language-desktop {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      ${Media.Nav} {
        display: none;
      }
    }

    .language-desktop .containerList {
      list-style-type: none;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      gap: 5px;
    }

    .language-desktop p {
      margin-bottom: 3px;

      ${Media.Tablet} {
        color: var(--branco-color) !important;
      }
    }

    .language-desktop .list button {
      text-transform: uppercase;
      font-size: 19px;
      font-weight: bold;
      position: relative;
      -webkit-transition: all 0.3s ease-out 0s;
      -moz-transition: all 0.3s ease-out 0s;
      -ms-transition: all 0.3s ease-out 0s;
      -o-transition: all 0.3s ease-out 0s;
      transition: all 0.3s ease-out 0s;
      cursor: pointer;
      background-color: transparent !important;
      padding: 0 0.4rem !important;
      color: var(--preto-color) !important;
      border-radius: 0 !important;

      ${Media.Laptop} {
        font-size: 1.1rem;
      }

      ${Media.Nav} {
        font-size: 20px;
        color: var(--branco-color) !important;
      }
    }

    .language-desktop .list button:hover {
      color: var(--vinho-color) !important;
      transition: all 0.5s;
    }

    .language-desktop .list button.selectLanguage {
      color: var(--vinho-color) !important;
      border-bottom: 1px solid var(--vinho-color);
    }
  }
`;
